export const MAX_NAME_LENGTH = 50;
export const MAX_EMAIL_LENGTH = 100;
export const MAX_APPLICATION_LETTER_LENGTH = 3000;
